import { type GetFrontNotificheParams } from '@framework/api-client/api/inquiries-compile/schemas/getFrontNotificheParams.ts';
import { GetFrontNotifichePriorita } from '@framework/api-client/api/inquiries-compile/schemas/getFrontNotifichePriorita.ts';
import { SortByNotifica } from '@framework/api-client/api/inquiries-compile/schemas/sortByNotifica.ts';
import { SortDirection } from '@framework/api-client/api/inquiries-compile/schemas/sortDirection.ts';
import { yup } from '@framework/validation/initYup.ts';

export type IFrontNotificationListSearchParams = Pick<
  GetFrontNotificheParams,
  | 'oggetto'
  | 'priorita'
  | 'flVista'
  | 'numeroIstanza'
  | 'dataNotificaDa'
  | 'dataNotificaA'
  | 'dataPresaVisioneDa'
  | 'dataPresaVisioneA'
  | 'sortField'
  | 'sortDirection'
  | 'firstResult'
  | 'maxResults'
> & {
  /**
   * ID tipo domanda per evitare che React Hook Form
   * interpreti il punto come path annidato. Viene rimappato a
   * `tipoDomanda.id` prima della chiamata API
   */
  tipoDomandaId?: string;
};

export const FrontNotificationListSearchSchema: yup.ObjectSchema<IFrontNotificationListSearchParams> =
  yup
    .object({
      oggetto: yup.string().label('Oggetto'),
      priorita: yup
        .string()
        .oneOfEnum(GetFrontNotifichePriorita)
        .label('Priorità'),
      flVista: yup.boolean().label('Vista'),
      numeroIstanza: yup.string().label('Numero Istanza'),
      tipoDomandaId: yup.string().label('Tipo Domanda'),
      dataNotificaDa: yup.string().stringDate().label('Da Data Notifica'),
      dataNotificaA: yup.string().stringDate().label('A Data Notifica'),
      dataPresaVisioneDa: yup
        .string()
        .stringDate('YYYY-MM-DD HH:mm')
        .label('Da Data Lettura'),
      dataPresaVisioneA: yup
        .string()
        .stringDate('YYYY-MM-DD HH:mm')
        .label('A Data Lettura'),

      sortField: yup.string().oneOfEnum(SortByNotifica).label('Ordinamento'),
      sortDirection: yup
        .string()
        .oneOfEnum(SortDirection)
        .label('Direzione ordinamento'),
      firstResult: yup.number().min(0).label('Offset'),
      maxResults: yup.number().min(1).label('Limite'),
    })
    .noUnknown()
    .required();
